import { useI18nContext } from "i18n/i18n-react"
import PropTypes from "prop-types"
export let globalLL = {}

const LegacyI18n = (props) => {
  const { LL } = useI18nContext()
  globalLL = LL
  return <>{props.children}</>
}

LegacyI18n.propTypes = {
  children: PropTypes.any,
}
export default LegacyI18n
